import { usePermittedRecentVisits } from "@/common/hooks/use-permitted-recent-visits";
import { normalizePath } from "@/store/recent-visits/_helpers/path";
import { HistoryIcon } from "lucide-react";
import { useMemo } from "react";
import { useLocation } from "wouter";
import type { PaletteCommand } from "../types";

export function useRecentVisitCommands(): PaletteCommand[] {
  const [location] = useLocation();
  const recentVisits = usePermittedRecentVisits();

  return useMemo(() => {
    const currentPath = normalizePath(location);

    return recentVisits
      .filter(({ visit }) => visit.path !== currentPath)
      .map(({ visit, navigationItem, moduleItem }) => {
        const Icon = moduleItem?.icon ?? navigationItem.icon ?? HistoryIcon;
        const moduleTitle = moduleItem?.title();

        return {
          id: visit.path,
          title: visit.title,
          subtitle: moduleTitle && !visit.title.startsWith(moduleTitle) ? moduleTitle : undefined,
          icon: <Icon />,
          keywords: moduleTitle ? [moduleTitle] : [],
          to: visit.path,
        };
      });
  }, [location, recentVisits]);
}
